export interface IChatSyncState {
  /** 
   * ID của Telegram session (ví dụ: sess-12345)
   * Chính là key chính để phân biệt multi-user/multi-device.
   */
  ownerId: string;

  /**
   * Chat ID chuẩn hóa từ Telegram (peer ID dương):
   * - user_id
   * - chat_id
   * - channel_id
   */
  chatId: number;

  /**
   * Message ID cuối cùng đã được đồng bộ hoàn chỉnh từ REST API.
   * Mốc này là "hậu phương tin cậy", không phụ thuộc WS.
   */
  lastSyncedMessageId: number;

  /**
   * Thời điểm sync REST gần nhất (ms epoch).
   * Dùng để quyết định khi nào cần sync lại.
   */
  lastSyncedAt: number;

  /**
   * Đánh dấu phiên bản của record (dùng khi bạn nâng cấp schema DB).
   */
  version?: number;
  chatTitle: string;
}
export function createDefaultChatSyncState(
  ownerId: string,
  chatId: number
): IChatSyncState {
  return {
    ownerId,
    chatId,
    lastSyncedMessageId: 0,
    lastSyncedAt: 0,
    version: 1,
    chatTitle: "",
  };
}